import Styled from 'styled-components';

const DragWrap = Styled.div`
.ant-card-body{
  // min-height: 600px;
}
  h1{
    margin-bottom: 20px;
  }
  .sDash_kanban-board-list{
    display: flex;
    margin: -10px;
    // flex-wrap: wrap
    flex-wrap: nowrap;
    // overflow-x: auto;
    // scrollbar-gutter: stable;
    overflow: hidden !important;
    .sDash_kanban-board-item{
    //   flex: 0 0 20%;
      // padding: 10px;
      // height: 400px;
      width:100%;
      padding: 5px;
      height: 500px;
      overflow: hidden;
      @media only screen and (max-width: 1599px){
        // flex: 0 0 21%;
      }
      @media only screen and (max-width: 1399px){
        // flex: 0 0 33.333%;
      }
      @media only screen and (max-width: 767px){
        // flex: 0 0 50%;
      }
      @media only screen and (max-width: 575px){
        // flex: 0 0 100%;
      }
      .sDash_kanban-board-item-scrolable{
        overflow: hidden; /* important */
      height: 100%;
        padding-bottom: 80px;
        border-radius: 5px;
        background-color: ${({ theme }) => theme['bg-color-normal']};
      }
      .sDash_addTask-control{
        padding-bottom: 20px;
        &.add-task-on{
          .sDash_addTask-from{
            display: block;
          }
          .btn-addTask{
            display: none;
          }
        }
        .sDash_addTask-from{
          padding: 0 20px 20px;
          display: none;
        }
        .sDash_addTask-input{
          padding: 10px;
          border-radius: 4px;
          background-color: #fff;
          width: 100%;
          height: 38px;
          border: 1px solid ${({ theme }) => theme['border-color-normal']};
          &:focus{
            outline: none;
          }
        }
        .sDash_addTask-action{
          margin-top: 10px;
          display: flex;
          align-items: center;
          .add-column{
            margin-right: 15px;
          }
          a{
            line-height: 1;
          }
          svg,
          i{
            color: ${({ theme }) => theme['gray-color']};
          }
        }
      }
    }
    .btn-addColumn{
      flex: 0 0 20%;
      @media only screen and (max-width: 1599px){
        flex: 0 0 25%;
      }
      @media only screen and (max-width: 1399px){
        flex: 0 0 33.333%;
      }
      @media only screen and (max-width: 767px){
        flex: 0 0 50%;
      }
      @media only screen and (max-width: 575px){
        flex: 0 0 100%;
      }
    }
    .sDash_kanban-board-item__header{
      padding: 18px 20px 10px 20px;
      position: relative;
      &.editable{
        .list-header-title{
          display: none;
        }
        .title-edit{
          display: block;
          height: 48px;
          border-color: ${({ theme }) => theme['primary-color']};
        }
      }
      .title-edit{
        width: 100%;
        padding: 0 15px;
        border: 1px solid #cdcdcd;
        height: 40px;
        line-height: 38px;
        border-radius: 4px;
        resize: none;
        display: none;
        transition: height .3s ease;
        &:focus{
          outline: none;
        }
      }
      .list-header-target{
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      .list-header-title{
        font-size: 15px;
        font-weight: 500;
        display:  flex;
        justify-content: space-between;
        margin-bottom: 0;
        .btn-more{
          padding: 0 4px;
          color: #868EAE;
          line-height: 1;
          position: relative;
          z-index: 22;
          svg,
          img{
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .sDash_kanvan-task{
      padding: 10px 20px 10px 20px;
    }
    .sDash_kanvan-task__single{
      position: relative;
      min-height: 48px;
      padding: 12px 15px;
      background-color: #fff;
      box-shadow: #0000000f -3px 5px 3px;
      // 0 0 5px #9299BB10;
      border-radius: 4px;
      cursor: all-scroll;
      &:not(:last-child){
        margin-bottom: 10px;
      }
      &:hover{
        .sDash_kanvan-task__title{
          .btn-edit{
            line-height: 1;
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
          }
        }
      }
      .sDash_kanvan-task__title{
        // font-size: 15px;
        font-size: 12px;
        font-weight: 500;
        margin: 0 5px 0 0;
        display: flex;
        justify-content: space-between;
        a{
          color: ${({ theme }) => theme['gray-color']};
        }
        .btn-edit{
          display: flex;
          align-items: center;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          svg,
          img{
            width: 14px;
            height: 14px;
            color: ${({ theme }) => theme['gray-color']};
          }
        }
      }
      .sDash_kanvan-task__edit{
        display: none;
      }
      .sDash_kanvan-task__editable{
        position: relative;
        .sDash_kanvan-task__edit{
          display: flex;
          position: absolute;
          left: -30px;
          top: -10px;
          z-index: 99999;
          width: calc(100% + 60px);
          border-radius: 4px;
          input{
            min-height: 58px;
          }
          button{
            padding: 0px 21.71px;
            height: 38px;
          }
          .sDash_kanvan-task__edit--right{
            .btn-delete{
              font-size: 12px;
              margin-left: 6px;
              white-space: nowrap;
              background-color: ${({ theme }) => theme['dark-color']};
              line-height: 2.6;
              display: flex;
              align-items: center;
              border-radius: 5px;
              padding: 0 8px;
              color: #fff;
              i,
              svg{
                color: #fff;
                margin-right: 4px;
              }
            }
          }
        }
        .edit-kanban-task{
          margin-top: 10px;
        }
      }
    }
    .sDash_kanvan-task__singleR{
      position: relative;
      min-height: 48px;
      padding: 12px 15px;
      background-color: #fff;
      box-shadow: 0 0 5px #9299BB10;
      border-radius: 4px;
      cursor: all-scroll;
      &:not(:last-child){
        margin-bottom: 10px;
      }
    }
    .btn-addTask{
      display: inline-block;
      width: calc(100% - 40px);
      padding: 8px 0;
      text-align: center;
      border-radius: 4px;
      position: relative;
      ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 20px;
      color: ${({ theme }) => theme['gray-color']};
      background-color: ${({ theme }) => theme['border-color-normal']};
      svg,
      i,
      img{
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 3px;
      }
    }
    .btn-addColumn{
      padding: 10px;
      &.add-column-on{
        .btn-addColumn-inner{
          .btn-add{
            display: none;
          }
          .btn-addColumn-form{
            display: block;
          }
        }
      }
      .btn-add{
        display: block;
        width: 100%;
        height: fit-content;
        border-radius: 5px;
        padding: 12px 20px;
        background-color: #F4F5F7;
        color: ${({ theme }) => theme['gray-color']};
        svg,
        i,
        img{
          margin-right: 3px;
        }
      }
      .btn-addColumn-inner{
        background-color: #F4F5F7;
        .sDash-add-column-input{
          padding: 10px;
          border-radius: 4px;
          background-color: #fff;
          width: 100%;
          height: 38px;
          border: 1px solid ${({ theme }) => theme['border-color-normal']};
          &:focus{
            outline: none;
          }
        }
      }
      .btn-addColumn-form{
        display: none;
        padding: 15px 20px 15px;
        .sDash_add-column-action{
          margin-top: 10px;
          display: flex;
          align-items: center;
          .add-column{
            margin-right: 15px;
          }
          a{
            line-height: 1;
          }
          svg,
          i{
            color: ${({ theme }) => theme['gray-color']};
          }
        }
      }
    }
  }
`;
export { DragWrap };